import styled from 'styled-components'

import {
    ColumnFlex,
    FlexCentered,
    RowFlex,
} from 'components/common/genericStyles'

export const Container = styled.div`
    ${ColumnFlex}
    justify-content: center;
    height: auto;
    background: #36383c;

    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08),
        0px 4px 12px -4px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin-top: 20px;

    button:first-child {
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
    }

    button:last-child {
        border-bottom-left-radius: inherit;
        border-bottom-right-radius: inherit;
    }
`

export const Item = {
    Area: styled.button`
        ${RowFlex}
        width: 100%;
        height: 40px;
        padding: 5px 0px;
        background: none;
        outline: none;
        border: none;
        cursor: pointer;

        &:hover {
            background: #ffffff24;
        }
    `,
    Icon: styled.span`
        height: 100%;
        ${FlexCentered}
        flex-basis: 20%;
    `,
    Copy: styled.span`
        flex-basis: 80%;
        height: 100%;
        height: 100%;
        ${FlexCentered}
        justify-content: flex-start;
        & > span {
            cursor: pointer;
        }
    `,
}
